import React from 'react';

export default ({ record }) => {
    const { success } = record.status.externalServices.hegnerMoeller;
	const color = success ? 'green' : 'red';
	const label = success ? 'Erfolgreich übermittelt' : 'Fehlgeschlagen';
    return <span className={`status ${color}`} title={label + ' - ' + status}></span>;
};
